<template>
  <div
    class="c-sidebarEntry o-flex -alignCenter"
    data-cy="SidebarProfile">
    <router-link
      :to="userProfileRoute"
      :tag="userProfileRoute.name ? 'a' : 'div'"
      class="o-flex -alignCenter s-profileHover t-noLinkAppearance"
      data-cy="SidebarProfile">
      <div
        class="c-avatar -medium "
        data-cy="SidebarProfile__avatar">
        <CurrentUserAvatar
          class="c-avatar__photo u-marginRight3" />
      </div>
      <div class="u-overflowXHidden">
        <div
          class="t-body3 t-fontWeightMedium t-overflowEllipsis">{{ username }}</div>
        <div class="t-caption1 u-colorDarkMediumEmphasis t-overflowEllipsis">{{ email }}</div>
      </div>
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      avatar: 'auth/avatar',
      username: 'auth/username',
      email: 'auth/email',
      userId: 'auth/userId',
      isProfilePageVisible: 'auth/isProfilePageVisible',
    }),
    userProfileRoute() {
      if (!this.isProfilePageVisible) {
        return {}
      }
      if (!this.userId) {
        return {}
      }
      return { name: 'profile.public', params: { userId: this.userId } }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/config';

.s-profileHover {
  border-radius: $spacing-4;
  padding: $spacing-1 $spacing-2;
  margin: -$spacing-1 0; // keep layout tight
  transition: background-color 0.2s ease-in-out;

  &:hover:is(a),
  &:focus:is(a) {
    background-color: $color-soft_highlight;
  }
}
</style>
